/** @type {import('tailwindcss').Config} */

// some tokens are using Figma DS values directly
// https://www.figma.com/design/Z55TCvaDUD5UcLxtztYIs4/Pepper-UI-Design-System--PUBLIC-?node-id=24187-17817&m=dev
export default {
  content: ["./src/**/*.{js,jsx,ts,tsx}"],
  theme: {
    screens: {
      sm: "375px", //smallest screen size we need to support
      md: "768px", //size for ipad mini
      lg: "1024px", //size for ipad pro
      xl: "1440px",
    },
    fontFamily: {
      sans: ["Plus Jakarta Sans", "sans-serif"],
      body: ["Roboto", "sans-serif"],
    },
    extend: {
      colors: {
        blue: {
          200: "rgba(194, 218, 254, 1)",
          400: "rgba(107, 165, 252, 1)",
          845: "rgba(26, 67, 124, 1)",
          875: "rgb(53,78,112)",
          800: "rgba(0, 62, 153, 1)",
        },
        grey: {
          100: "rgba(247, 247, 247, 1)",
          125: "rgba(229, 231, 235, 1)",
          900: "rgba(26, 27, 27, 1)",
        },
        "light-product-text-subdued": "rgb(101,101,101)",
        "surface-accent-red-subtler": "rgba(247, 208, 204, 1)",
        surface: {
          emphasis: "rgba(3, 49, 116, 1)",
          foreground: "rgba(247, 247, 247)",

          "foreground-brand": "rgba(245, 249, 255,1)",
          "base-brand": "rgb(245, 249, 255)",

          tags: {
            subtle: {
              dark: { base: "rgba(3, 20, 46, 0.05)" },
            },
            grey: "rgba(230, 230, 230, 1)",
            blue: "rgba(240, 246, 255, 1)",
            amber: "rgba(255, 237, 203, 1)",
            green: "rgba(217, 248, 205, 1)",
          },
          base: {
            background: "rgba(255, 255, 255, 1)",
          },

          /* Figma design tokens */
          primary: "rgba(255, 255, 255, 1)",
          secondary: "rgba(247, 248, 249, 1)",
          disabled: "rgba(3, 20, 46, 0.05)",
          transparent: "rgba(255, 255, 255, 0)",
          brand: {
            subtle: "rgba(245, 249, 255, 1)",
            default: "rgba(0, 100, 250, 1)",
            bold: "rgba(3, 49, 116, 1)",
          },
          negative: {
            default: "rgba(214, 49, 59, 1)",
            bold: "rgba(174, 35, 43, 1)",
          },
          positive: {
            default: "rgba(0,133,0,1)",
            bold: "rgba(0,112,0,1)",
          },
          tonal: {
            default: "rgba(3, 20, 46, 0.05)",
            bold: "rgba(3, 20, 46, 0.1)",
            bolder: "rgba(3, 20, 46, 0.3)",
            boldest: "rgba(3, 20, 46, 0.7)",
          },
          accent: {
            amber: {
              default: "rgba(226, 137, 18, 1)",
              bold: "rgba(191, 113, 9, 1)",
              subtle: "rgba(248, 206, 152, 1)",
              subtler: "rgba(255, 237, 203, 1)",
            },
            blue: {
              subtle: "rgba(153, 193, 253, 1)",
              subtler: "rgba(194, 218, 254, 1)",
            },
            green: {
              subtler: "rgba(202, 249, 204, 1)",
            },
            violet: {
              subtler: "rgba(249, 233, 255, 1)",
            },
          },

          inverse: {
            primary: "rgba(3, 20, 46, 1)",
            brand: {
              default: "rgba(61, 137, 250, 1)",
            },
          },
        },
        text: {
          base: "rgba(26, 27, 27, 1)",
          success: "rgba(0,133,0)",
          subdued: "rgba(138,139,139,1)",
          blue: "rgba(0,100,250, 1)",
          alert: "rgba(139, 79, 0, 1)",
          "base-secondary": "rgba(98, 111, 134, 1)",
          "base-primary": "rgb(3, 20, 46)",
          "base-subdued": "rgb(133, 144, 162)",
          "base-alert": "rgb(214, 49, 59)",
          "base-failed": "rgb(174, 35, 43)",
          "base-pending": "rgb(191, 113, 9)",
          "link-hover": "rgba(0, 82, 204, 1)",

          /* Figma design tokens */
          primary: "rgba(3,20,46,1)",
          secondary: "rgba(3, 20, 46, 0.6)",
          tertiary: "rgba(3, 20, 46, 0.6)",
          disabled: "rgba(3, 20, 46, 0.2)",
          error: "rgba(214, 49, 59, 1)",
          selected: "rgba(0, 100, 250, 1)",
          brand: {
            default: "rgba(0, 100, 250, 1)",
            bold: "rgba(0, 82, 204, 1)",
            boldest: "rgba(3, 49, 116, 1)",
          },
          link: {
            default: "rgba(0, 100, 250, 1)",
            visited: "rgba(127, 0, 173, 1)",
          },
          warning: {
            default: "rgba(226, 137, 18, 1)",
            bold: "rgba(191, 113, 9, 1)",
            boldest: "rgba(104, 59, 0, 1)",
          },
          negative: {
            default: "rgba(214, 49, 59, 1)",
            bold: "rgba(174, 35, 43, 1)",
            boldest: "rgba(104, 59, 0, 1)",
          },
          positive: {
            default: "rgba(0, 133, 0, 1)",
            bold: "rgba(0, 112, 0, 1)",
            boldest: "rgba(14, 54, 26, 1)",
          },
          informative: {
            default: "rgba(0, 100, 250, 1)",
            bold: "rgba(0, 82, 204, 1)",
            boldest: "rgba(3, 49, 116, 1)",
          },

          inverse: {
            primary: "rgba(255, 255, 255, 1)",
          },
          accent: {
            amber: {
              default: "rgba(226, 137, 18, 1)",
              bold: "rgba(191, 113, 9, 1)",
              boldest: "rgba(104, 59, 0, 1)",
            },
            blue: {
              boldest: "rgba(3, 49, 116, 1)",
            },
            green: {
              default: "rgba(0, 133, 0, 1)",
              bold: "rgba(0, 112, 0, 1)",
              boldest: "rgba(14, 54, 26, 1)",
            },
            red: {
              boldest: "rgba(92, 19, 23, 1)",
            },
            violet: {
              bold: "rgba(127, 0, 173, 1)",
            },
          },
        },
        cta: {
          background: { secondary: { base: "rgba(247, 247, 247)" } },
          selected: { base: "rgba(26, 27, 27, 1)" },
          secondary: { "hover--dark": "rgba(240, 246, 255, 0.15)" },
        },
        icon: {
          base: "rgba(26, 27, 27, 1)",
          subdued: "rgba(113, 114, 114, 1)",

          /* Figma design tokens */
          primary: "rgba(3, 20, 46, 1)",
          secondary: "rgba(3, 20, 46, 0.8)",
          tertiary: "rgba(3, 20, 46, 0.6)",
          disabled: "rgba(3, 20, 46, 0.2)",
          error: "rgba(214, 49, 59, 1)",
          selected: "rgba(0, 100, 250, 1)",

          brand: {
            default: "rgba(0, 100, 250, 1)",
            bold: "rgba(0, 82, 204, 1)",
            boldest: "rgba(3, 49, 116, 1)",
          },
          warning: {
            default: "rgba(226, 137, 18, 1)",
            bold: "rgba(191, 113, 9, 1)",
            boldest: "rgba(104, 59, 0, 1)",
          },
          accent: {
            violet: {
              bold: "rgba(127, 0, 173, 1)",
            },
          },
        },
        background: {
          base: "rgba(247,247,247, 1)",
          success: "rgba(217,248,205)",
          warning: "rgba(255,237,203)",
          primary: "rgba(230,230,230)",
          blue: "rgba(240,246,255)",
          "white-blue": "rgba(205, 232, 248, 1)",
          table: {
            hover: "rgba(0, 100, 250, 0.05)",
            highlight: "rgba(0, 100, 250, 0.14)",
          },
          loading: "rgba(21, 21, 21, 0.05)",
          alert: "rgba(255, 247, 236, 1)",
          failed: "rgb(247, 208, 204)",
          pending: "rgb(255, 237, 203)",
          purple: "rgba(214, 205, 248, 1)",
        },
        semantic: {
          surface: {
            foreground: "rgba(247, 247, 247, 1)",
            black: "rgba(26, 27, 27, 1)",
          },
        },
        border: {
          primary: {
            base: "rgba(230,230,230,1)",
            strong: "rgba(163, 164, 164, 1)",
            medium: "rgba(190, 191, 191, 1)",
          },
          blue: {
            base: "rgba(0, 100, 250, 1)",
            400: "rgba(107, 165, 252, 1)",
          },
          neutral: {
            base: "rgba(220,223,228,1)",
          },
        },
        /* Figma design tokens */
        stroke: {
          primary: "rgba(3, 20, 46, 0.1)",
          secondary: "rgba(3, 20, 46, 0.05)",
          tertiary: "rgba(3, 20, 46, 0.02)",
          neutral: "rgba(3,20,46,1)",
          error: "rgba(214, 49, 59, 1)",
          focused: "rgba(71, 145, 255, 1)",
          selected: "rgba(0, 100, 250, 1)",
          stroke: "rgba(3, 20, 46, 0)",
        },
        product: {
          button: {
            bg: {
              secondary: {
                default: "rgb(21, 21, 21, 0.05)",
              },
              selected: {
                default: "rgba(21, 21, 21, 1)",
              },
            },
          },
          form: {
            bg: {
              default: "rgba(21, 21, 21, 0.02)",
            },
            border: {
              default: "rgba(214, 214, 214, 1)",
            },
          },
        },
        state: {
          selected: "rgba(0, 100, 250, 0.05)",
        },
        //opacity will conflict with Tailwind's opacity utilities, so we use "overlay" to differentiate
        overlay: {
          opacity: {
            state: {
              hover: "rgba(3, 20, 46, 0.05)",
              pressed: "rgba(3, 20, 46, 0.1)",
              selected: "rgba(0, 100, 250, 0.05)",
              bold: {
                hover: "rgba(3, 20, 46, 0.2)",
                pressed: "rgba(3, 20, 46, 0.3)",
              },
              inverse: {
                hover: "rgba(255,255,255,0.1)",
                pressed: "rgba(255,255,255,0.2)",
                selected: "rgba(153,193,253,0.2)",
                bold: {
                  hover: "rgba(255,255,255,0.3)",
                  pressed: "rgba(255,255,255,0.4)",
                },
              },
            },
          },
        },
      },
      spacing: { "right-sidebar": "400px" },
      keyframes: {
        modalFadeIn: {
          "0%": { opacity: "0" },
          "100%": { opacity: "1" },
        },
        modalScaleIn: {
          "0%": { transform: "scale(0.95)", opacity: 0 },
          "100%": { transform: "scale(1)", opacity: 1 },
        },
        rowHighlight: {
          "0%, 100%": { backgroundColor: "transparent" },
          "20%, 60%": { backgroundColor: "rgba(0, 100, 250, 0.14)" },
        },
      },
      animation: {
        "modal-fade-in": "modalFadeIn 0.2s ease-out",
        "modal-scale-in": "modalScaleIn 0.2s ease-out",
        "row-highlight": "rowHighlight 1.2s ease-in-out",
      },
      zIndex: {
        // Floating panels (dropdowns, popovers) rendered `fixed` above modal shells (`z-50`)
        floating: "9999",
      },
      boxShadow: {
        dropdown:
          "0 -4px 8px 0 rgba(3, 20, 46, 0.05), 0 -8px 16px 0 rgba(3, 20, 46, 0.05), 0 -16px 32px 8px rgba(3, 20, 46, 0.02)",
        elevation:
          "0 4px 8px 0 rgba(3, 20, 46, 0.05), 0 8px 16px 0 rgba(3, 20, 46, 0.05), 0 16px 32px 8px rgba(3, 20, 46, 0.05)",
      },
    },
  },
  plugins: [],
};
